import { put, select } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { setTransformationMapTopic } from "domains/transformationMap/actions";
import type { TransformationMapUpdateTopicAction } from "domains/transformationMap/actionTypes";
import { fetchTopicSuccess } from "entities/topics/actions";
import { createTopicSelector } from "entities/topics/selectors";
import type { Topic } from "entities/topics/types";
import { router } from "router/router";

export function* updateMapTopicSaga(action: TransformationMapUpdateTopicAction) {
  const { id } = action.meta;
  const { pathname, search } = location;

  const topic: ReturnType<ReturnType<typeof createTopicSelector>> = yield select(createTopicSelector(id));

  if (!topic?.isTMLoaded) {
    const newTopic: Topic = yield apiFetch(`map/${id}`);
    yield put(fetchTopicSuccess({ topic: newTopic }));
  }

  const productDomain = pathname.split("/")[1];
  if (!["topics", "discover", "create"].includes(productDomain)) return;

  const newUrl = `/${productDomain}/${id}${search}`;
  if (`${pathname}${search}` !== newUrl) yield router.navigate(newUrl);

  yield put(setTransformationMapTopic(action.meta));
}
